// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface ProductOptionsTableLinkStyles {
    wrapper?: InjectableCss;
    link?: LinkPresentationProps;
}

export const productOptionsTableLinkStyles: ProductOptionsTableLinkStyles = {
    wrapper: {
        css: css`
            padding: 8px;
            border: 1px solid ${color("common.border")};
            line-height: ${fontConfig.singleLineSmall.lineHeight};
            font-size: ${fontConfig.singleLineSmall.size}px;
        `,
    },
    link: {
        typographyProps: {
            weight: fontConfig.weight.medium,
            size: fontConfig.singleLineSmall.size,
        },
    },
};

const styles = productOptionsTableLinkStyles;

export const anchorId = "productOptinsTableId";
const ProductOptionsTableLink = () => {
    const goToAnchor = () => {
        const element = document.querySelector<HTMLElement>(`#${anchorId}`);
        if (!element) {
            return;
        }

        const headerOffset = 75; // height of sticky header
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            {translate("Refine your product below or compare all choices in the ")}
            <Link {...styles.link} onClick={goToAnchor}>
                {translate("complete product option table.")}
            </Link>
        </StyledWrapper>
    );
};

export default ProductOptionsTableLink;
